export var ClientTypeApi;
(function (ClientTypeApi) {
    ClientTypeApi["WEB"] = "web";
    ClientTypeApi["CAPACITOR_IOS"] = "capacitor_ios";
    ClientTypeApi["CAPACITOR_ANDROID"] = "capacitor_android";
})(ClientTypeApi || (ClientTypeApi = {}));
